export * from './message-center';
export * from './shared';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/core/message/index.ts